import {takeLatest} from 'redux-saga/effects';

import {getBreweryBeersSaga, getSingleBrewery} from './get/saga';
import {getBreweryBeersACS, getSingleBreweryACS, updateSingleBreweryACS} from './requestAC';
import {updateBrewery} from './update/saga';

export default function* singleBrewerySaga() {
  yield takeLatest(getSingleBreweryACS.type, getSingleBrewery);
  yield takeLatest(getBreweryBeersACS.type, getBreweryBeersSaga);
  yield takeLatest(updateSingleBreweryACS.type, updateBrewery);
}
